<template>
  <v-container class="settings">
    <router-view />
  </v-container>
</template>

<script>
export default {
  name: "Layout",
};
</script>

<style scoped></style>
